import { ICON_TYPES } from '../constants';

export const CopyLinkIcon = () => {
  return (
    <svg
      width="28"
      height="29"
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="1" width="27" height="27" rx="13.5" fill="#F8FAFC" />
      <g>
        <path
          d="M13.2921 18.7648C12.8186 19.2257 12.1826 19.4816 11.5218 19.4772C10.8611 19.4728 10.2286 19.2084 9.76128 18.7412C9.29396 18.274 9.02937 17.6416 9.02475 16.9808C9.02014 16.32 9.27587 15.684 9.73662 15.2103L11.8676 13.0778L11.1601 12.3708L9.02962 14.5033C8.37076 15.1625 8.00074 16.0565 8.00098 16.9885C8.00121 17.9205 8.37168 18.8142 9.03087 19.4731C9.69007 20.132 10.584 20.502 11.516 20.5017C12.448 20.5015 13.3418 20.131 14.0006 19.4718L16.1316 17.3408L15.4246 16.6338L13.2921 18.7648Z"
          fill="#141414"
        />
        <path
          d="M18.9721 9.53076C18.6468 9.20316 18.2596 8.9434 17.8331 8.7665C17.4067 8.58961 16.9493 8.49912 16.4876 8.50026C16.0262 8.49903 15.569 8.5893 15.1427 8.76583C14.7163 8.94237 14.3291 9.20167 14.0036 9.52876L11.8701 11.6603L12.5771 12.3678L14.7096 10.2368C14.9424 10.0026 15.2193 9.81691 15.5243 9.69049C15.8294 9.56406 16.1564 9.49941 16.4866 9.50026C16.9838 9.50042 17.4697 9.64797 17.883 9.92426C18.2962 10.2005 18.6183 10.5932 18.8085 11.0525C18.9987 11.5118 19.0485 12.0172 18.9515 12.5047C18.8545 12.9923 18.6151 13.4402 18.2636 13.7918L16.1326 15.9228L16.8401 16.6303L18.9711 14.5003C19.6291 13.8408 19.9988 12.9473 19.999 12.0157C19.9992 11.0841 19.6299 10.1905 18.9721 9.53076Z"
          fill="#141414"
        />
        <path
          d="M15.4233 12.3709L11.8711 15.9231L12.5782 16.6302L16.1304 13.0781L15.4233 12.3709Z"
          fill="#141414"
        />
      </g>
      <rect x="0.5" y="1" width="27" height="27" rx="13.5" stroke="#43494F" />
    </svg>
  );
};

CopyLinkIcon.iconType = ICON_TYPES.COPY_LINK;
